import React, {useEffect, useState} from 'react';
import {Template} from "../../../../components/template/template.jsx";
import {APIProvider, ControlPosition, Map} from "@vis.gl/react-google-maps";
import {useQuery} from "@tanstack/react-query";
import corporationService from "../../../../services/web/corporation-service.js";
import PointLayerForm from "./point-layer-form.jsx";
import PointLayerProvider from "./point-layer-context.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaPlus} from "react-icons/fa";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {useParams} from "react-router";

const PointLayerFormIndex = () => {
    const navigate = navigateHook();
    const {id} = useParams()
    const [isLoading, setIsLoading] = useState(false)

    const {data: corporation, isSuccess, isLoading: isLoadingCorporation} = useQuery({
        queryFn: () => corporationService.entity(),
        queryKey: ["corporation"]
    });

    const latitude = parseFloat(corporation?.latitude) || 0;
    const longitude = parseFloat(corporation?.longitude) || 0;

    const position = {
        lat: latitude,
        lng: longitude
    }

    const openForm = () => {
        const urlDev = `/point-layer/form`;
        navigate(urlDev)
    }

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>Ponto</Template.Title>

                {
                    id &&
                    <Button onClick={openForm} target={"primary-outline"}>
                        <FaPlus/> Adicionar ponto
                    </Button>
                }
            </Template.Header>
            <Template.Body className={`!p-0 h-[calc(100vh-53px)]`}>
                {
                    !isSuccess &&
                    <div className="animate-pulse h-full">
                        <div className="h-full bg-gray-200"></div>
                    </div>
                }

                {
                    isSuccess &&
                    <APIProvider apiKey={corporation?.maps_api_key ?? ""}>
                        <Map
                            styles={[
                                {
                                    "elementType": 'labels', "stylers": [
                                        {
                                            "visibility": 'ON'
                                        }
                                    ]
                                },
                                {
                                    "featureType": "poi",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "visibility": 'off'
                                        }
                                    ]
                                },
                                {
                                    "featureType": "road",
                                    "elementType": "labels.text.fill",
                                    "stylers": [
                                        {
                                            "visibility": 'on'
                                        }
                                    ]
                                },
                            ]}
                            defaultZoom={12}
                            streetViewControl={true}
                            fullscreenControl={false}
                            defaultCenter={position}
                            gestureHandling={'greedy'}
                            style={{height: "100%", width: "100%"}}
                            mapTypeControlOptions={{position: ControlPosition.TOP_RIGHT}}
                        >
                            <PointLayerProvider id={id} setIsLoading={setIsLoading} position={position}>
                                <PointLayerForm />
                            </PointLayerProvider>
                        </Map>
                    </APIProvider>
                }
            </Template.Body>
        </Template>
    );
};

export default PointLayerFormIndex;